export const PRODUCTS = [
  'TextApp',
  'LiveChat',
  'ChatBot',
  'HelpDesk',
  'KnowledgeBase',
  'OpenWidget',

  // Platform release: remember to comment out Platform before official release
  // cannot be handled by Unleash as it requires authentication
  // 'Platform',

  'PartnerProgram',
];
